export const pa = {
  tip: "ਸੁਝਾਅ",
  fatInputTip: "ਜੇਕਰ ਤੁਸੀਂ {val}.0 ਲਿਖਣਾ ਚਾਹੁੰਦੇ ਹੋ ਤਾਂ ਦਸ਼ਮਲਵ ਦੇ ਨਾਲ ਸਹੀ ਮੁੱਲ ਦਰਜ ਕਰੋ ਜਾਂ 3 ਅੰਕਾਂ ਦੇ ਨਾਲ {val}0 ਦਰਜ ਕਰੋ।",
  snfInputTip: "ਜੇਕਰ ਤੁਸੀਂ {val}.0 ਲਿਖਣਾ ਚਾਹੁੰਦੇ ਹੋ ਤਾਂ ਦਸ਼ਮਲਵ ਦੇ ਨਾਲ ਸਹੀ ਮੁੱਲ ਦਰਜ ਕਰੋ ਜਾਂ 3 ਅੰਕਾਂ ਦੇ ਨਾਲ {val}0 ਦਰਜ ਕਰੋ।",
  // Header/Navigation
  // appTitle: "ਦੁਧੀਆ: ਦੁੱਧ ਪ੍ਰਬੰਧਨ ਸਿਸਟਮ",
  home: "ਹੋਮ",
  logout: "ਲਾਗਆਉਟ",

  // Hire Person
  hirePersonBannerHeading: "ਕੀ ਤੁਸੀਂ ਖੁਦ ਇਕੱਠਾ ਕਰਨਾ ਨਹੀਂ ਚਾਹੁੰਦੇ?",
  hirePersonBannerSubheading: "ਇਕੱਠਾ ਲਈ ਇੱਕ ਵਿਅਕਤੀ ਕਿਰਾਏ ਤੇ ਲਵੋ",
  hirePersonModalTitle: "ਇਕੱਠਾ ਲਈ ਵਿਅਕਤੀ ਕਿਰਾਏ ਤੇ ਲਵੋ",
  hirePersonCostEstimate: "ਲਾਗਤ ਅਨੁਮਾਨ",
  hirePersonCostEstimateDesc: "ਕੀਮਤ ਆਮ ਤੌਰ ਤੇ ₹500 ਤੋਂ ₹3,000-₹4,000 ਪ੍ਰਤੀ ਮਹੀਨਾ ਤੱਕ ਹੁੰਦੀ ਹੈ, ਇਹ ਔਸਤ ਰੋਜ਼ਾਨਾ ਇਕੱਠਾ ਦੀ ਗਿਣਤੀ ਅਤੇ ਲੋੜੀਂਦੇ ਕੰਮ ਦੀ ਮਾਤਰਾ ਦੇ ਅਧਾਰ ਤੇ ਵੱਖਰੀ ਹੁੰਦੀ ਹੈ।",
  hirePersonContactNetpy: "ਦੁਧੀਆ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
  hirePersonContactNetpyDesc: "ਇੱਕ ਅਨੁਕੂਲਿਤ ਹਵਾਲਾ ਪ੍ਰਾਪਤ ਕਰਨ ਅਤੇ ਆਪਣੇ ਖੇਤਰ ਵਿੱਚ ਭਰੋਸੇਯੋਗ ਇਕੱਠਾ ਕਰਮਚਾਰੀਆਂ ਨਾਲ ਜੁੜਨ ਲਈ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
  hirePersonCallNetpy: "ਕਾਲ ਨੈੱਟਪੀ",
  hirePersonWhatsAppNetpy: "ਵ੍ਹਾਟਸਐਪ ਨੈੱਟਪੀ",

  // Dashboard
  dashboard: "ਡੈਸ਼ਬੋਰਡ",
  dairyName: "ਡੇਅਰੀ ਦਾ ਨਾਮ",
  walletBalance: "ਵਾਲਿਟ ਬੈਲੈਂਸ",
  addMoney: "ਪੈਸੇ ਜੋੜੋ",
  notAvailable: "ਉਪਲਬਧ ਨਹੀਂ",

  // Rate Information
  milkRate: "ਦੁੱਧ ਦੀ ਦਰ",
  currentRate: "ਮੌਜੂਦਾ ਦਰ",
  currentMilkRate: "ਮੌਜੂਦਾ ਦੁੱਧ ਦੀ ਦਰ",
  editRate: "ਦਰ ਸੋਧੋ",
  rateType: "ਦਰ ਦਾ ਕਿਸਮ",
  selectRateType: "ਦਰ ਦੀ ਕਿਸਮ ਚੁਣੋ",
  submit: "ਜਮ੍ਹਾਂ ਕਰੋ",
  submitting: "ਜਮ੍ਹਾਂ ਹੋ ਰਿਹਾ ਹੈ...",
  save: "ਸੰਭਾਲੋ",
  saving: "ਸੰਭਾਲਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
  cancel: "ਰੱਦ ਕਰੋ",

  // Dashboard Cards
  bulkRateUpdate: "ਬਲਕ ਵਿੱਚ ਦੁੱਧ ਦੀ ਰੇਟ ਬਦਲੋ",
  bulkRateUpdateBtn: "ਦਰ ਬਦਲੋ",
  rateSettings: "ਦਰ ਸੈਟਿੰਗਾਂ",
  bulkRateUpdateTooltip: "ਕਈ ਕਲੈਕਸ਼ਨਾਂ ਲਈ ਦੁੱਧ ਦੀ ਦਰ ਬਦਲੋ",
  updateRatesForMultipleCollections: "ਕਈ ਕਲੈਕਸ਼ਨਾਂ ਲਈ ਦਰਾਂ ਅਪਡੇਟ ਕਰੋ",
  configureMilkPricingAndRateTypes: "ਦੁੱਧ ਦੀਆਂ ਕੀਮਤਾਂ ਅਤੇ ਦਰ ਦੀਆਂ ਕਿਸਮਾਂ ਕੌਂਫਿਗਰ ਕਰੋ",
  updateMultipleCollectionsAtOnce: "ਇੱਕੋ ਵਾਰ ਕਈ ਕਲੈਕਸ਼ਨਾਂ ਅਪਡੇਟ ਕਰੋ",
  previewBeforeApplyingChanges: "ਬਦਲਾਅ ਲਾਗੂ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਝਲਕ ਦਿਖਾਓ",
  setCurrentMilkRate: "ਮੌਜੂਦਾ ਦੁੱਧ ਦਰ ਸੈੱਟ ਕਰੋ",
  setMilkRateNow: "ਆਪਣਾ ਦੁੱਧ ਦਰ ਹੁਣੇ ਸੈੱਟ ਕਰੋ!",
  managePricingParameters: "ਕੀਮਤ ਪੈਰਾਮੀਟਰਾਂ ਦਾ ਪ੍ਰਬੰਧ ਕਰੋ",
  applyToSpecificDateRanges: "ਖਾਸ ਤਾਰੀਖ ਸੀਮਾਵਾਂ 'ਤੇ ਲਾਗੂ ਕਰੋ",
  configureRateType: "ਦਰ ਦੀ ਕਿਸਮ ਕੌਂਫਿਗਰ ਕਰੋ (FAT+SNF, FAT+CLR, ਆਦਿ)",

  // Collection Cards
  regularMilkCollections: "ਨਿਯਮਿਤ ਦੁੱਧ ਕਲੈਕਸ਼ਨ",
  proportionalCollections: "ਅਨੁਪਾਤੀ ਕਲੈਕਸ਼ਨ",
  generateDetailedReports: "ਵਿਸਥਾਰਤ ਰਿਪੋਰਟ ਬਣਾਓ",
  proRataCollection: "ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ",
  standardCollection: "ਸਟੈਂਡਰਡ ਕਲੈਕਸ਼ਨ",
  notAvailableWithKGLitersRateType: "ਕਿਗ/ਲੀਟਰ ਰੇਟ ਕਿਸਮ ਨਾਲ ਉਪਲਬਧ ਨਹੀਂ",
  selectCollectionType: "ਕਲੈਕਸ਼ਨ ਦੀ ਕਿਸਮ ਚੁਣੋ",
  applyFilter: "ਫਿਲਟਰ ਲਾਗੂ ਕਰੋ",
  applying: "ਲਾਗੂ ਹੋ ਰਿਹਾ ਹੈ...",
  applyRateChanges: "ਰੇਟ ਬਦਲਾਅ ਲਾਗੂ ਕਰੋ",

  // Wallet Modal
  addToWallet: "ਵਾਲੇਟ ਵਿੱਚ ਜੋੜੋ",
  topUpWalletInstantlyUsingRazorpay: "ਰੇਜ਼ਰਪੇ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਤੁਰੰਤ ਆਪਣਾ ਵਾਲੇਟ ਟਾਪ ਅੱਪ ਕਰੋ",
  quickRecharge: "ਤੇਜ਼ ਰੀਚਾਰਜ",
  walletRecharge: "ਰੀਚਾਰਜ",

  // Add Money Modal
  moneyAddedToWalletMessage: "ਸਫਲ ਭੁਗਤਾਨ ਤੋਂ ਬਾਅਦ 5 ਮਿੰਟਾਂ ਦੇ ਅੰਦਰ ਪੈਸੇ ਤੁਹਾਡੇ ਵਾਲੇਟ ਵਿੱਚ ਜੋੜ ਦਿੱਤੇ ਜਾਣਗੇ।",
  refreshPage: "ਸਫ਼ਾ ਰਿਫਰੈਸ਼ ਕਰੋ",
  please: "ਕਿਰਪਾ ਕਰਕੇ",
  enterAmount: "ਰਕਮ ਦਾਖਲ ਕਰੋ",
  enterValidAmount: "ਠੀਕ ਰਕਮ ਦਾਖਲ ਕਰੋ (₹1 ਜਾਂ ਵੱਧ)",
  youWillGetExtraOnRecharge: "ਤੁਸੀਂ ਇਸ ਰੀਚਾਰਜ 'ਤੇ ₹{amount} ਵਾਧੂ ਪਾਓਗੇ!",
  youWillGet10PercentBonus: "ਤੁਸੀਂ ਇਸ ਰੀਚਾਰਜ 'ਤੇ ₹{amount} ਵਾਧੂ ਪਾਓਗੇ!",
  youWillGet5PercentBonus: "ਤੁਸੀਂ ਇਸ ਰੀਚਾਰਜ 'ਤੇ ₹{amount} ਵਾਧੂ ਪਾਓਗੇ!",
  continueToPayment: "ਭੁਗਤਾਨ ਜਾਰੀ ਰੱਖੋ",
  loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",

  // Rate Settings Modal
  saveSettings: "ਸੈਟਿੰਗਾਂ ਸੰਭਾਲੋ",
  perKg: "/ਕਿਗ",
  milkRateHeading: "ਦੁੱਧ ਦੀ ਦਰ",
  milkRateAndRateSettingsSavedSuccessfully: "ਦੁੱਧ ਦਰ ₹{currentRate}/ਕਿਗ ਅਤੇ ਦਰ ਸੈਟਿੰਗਾਂ ਸਫਲਤਾਪੂਰਵਕ ਸੰਭਾਲੀਆਂ ਗਈਆਂ!",

  // Collections
  addCollection: "ਥੋਕ ਸੰਗ੍ਰਹਿ",
  viewCollections: "ਸੰਗ੍ਰਹਿ ਵੇਖੋ",
  standardCollections: "ਮਿਆਰੀ ਸੰਗ੍ਰਹਿ",
  proRataCollections: "ਪ੍ਰੋ-ਰਾਟਾ ਸੰਗ੍ਰਹਿ",
  quickFiltersAndActions: "ਤੇਜ਼ ਫਿਲਟਰ ਅਤੇ ਕਾਰਵਾਈਆਂ",
  refineCollectionsAndManageRatesInstantly: "ਆਪਣੇ ਸੰਗ੍ਰਹਿਆਂ ਨੂੰ ਸੁਧਾਰੋ ਅਤੇ ਤੁਰੰਤ ਦਰਾਂ ਪ੍ਰਬੰਧਤ ਕਰੋ",
  proRataFiltersAndActions: "ਪ੍ਰੋ-ਰਾਟਾ ਫਿਲਟਰ ਅਤੇ ਕਾਰਵਾਈਆਂ",
  targetCollectionsAndUpdateProRataRatesFaster: "ਸੰਗ੍ਰਹਿਆਂ ਨੂੰ ਨਿਸ਼ਾਨਾ ਬਣਾਓ ਅਤੇ ਪ੍ਰੋ-ਰਾਟਾ ਦਰਾਂ ਤੇਜ਼ੀ ਨਾਲ ਅਪਡੇਟ ਕਰੋ",
  proRataBadge: "ਪ੍ਰੋ ਰਾਟਾ",

  // Customer Management
  addCustomer: "ਗਾਹਕ ਜੋੜੋ",
  viewCustomers: "ਗਾਹਕ ਵੇਖੋ",
  customerName: "ਗਾਹਕ ਦਾ ਨਾਮ",
  phoneNumber: "ਫੋਨ ਨੰਬਰ",

  // Reports
  generateReports: "ਰਿਪੋਰਟ ਬਣਾਓ",
  reports: "ਰਿਪੋਰਟਾਂ",
  generateStandardReport: "ਰਿਪੋਰਟ ਤਿਆਰ ਕਰੋ",
  generateProRataReport: "ਰਿਪੋਰਟ ਤਿਆਰ ਕਰੋ",

  // Wallet
  wallet: "ਵਾਲਿਟ",
  addFunds: "ਪੈਸੇ ਜੋੜੋ",
  amount: "ਰਕਮ",
  paymentSuccessful: "ਭੁਗਤਾਨ ਸਫਲ! ਤੁਹਾਡਾ ਵਾਲਿਟ ਜਲਦੀ ਅਪਡੇਟ ਹੋ ਜਾਵੇਗਾ।",
  paymentSuccessfulWithAmount: "✅ ਭੁਗਤਾਨ ਸਫਲ! ₹{amount} ਤੁਹਾਡੇ ਵਾਲਟ ਵਿੱਚ ਜੋੜ ਦਿੱਤਾ ਗਿਆ।",
  paymentFailed: "ਭੁਗਤਾਨ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  paymentCancelled: "ਭੁਗਤਾਨ ਰੱਦ। ਜੇ ਤੁਸੀਂ ਪੈਸੇ ਜੋੜਨਾ ਚਾਹੁੰਦੇ ਹੋ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  paymentSessionTimedOut: "ਭੁਗਤਾਨ ਸਮਾਂ ਸਮਾਪਤ। ਕਿਰਪਾ ਕਰਕੇ ਚੈਕ ਕਰੋ ਕਿ ਭੁਗਤਾਨ ਪੂਰਾ ਹੋਇਆ ਜਾਂ ਨਹੀਂ।",
  paymentCancelledOrIncomplete: "ਭੁਗਤਾਨ ਰੱਦ ਜਾਂ ਅਧੂਰਾ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  unableToVerifyPaymentStatus: "ਭੁਗਤਾਨ ਸਥਿਤੀ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਵਾਲਟ ਬੈਲੇਂਸ ਦੀ ਜਾਂਚ ਕਰੋ।",

  // Collection Details
  singleDateShift: "ਇੱਕ ਤਾਰੀਖ/ਸ਼ਿਫਟ",
  multiDateShift: "ਬਹੁ-ਤਾਰੀਖ/ਸ਼ਿਫਟ",
  date: "ਤਾਰੀਖ",
  time: "ਸਮਾਂ",
  dateTime: "ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ",
  customer: "ਗਾਹਕ",
  weight: "ਭਾਰ",
  fatPercentage: "FAT %",
  snfPercentage: "SNF %",
  fatKg: "ਚਰਬੀ ਕਿਲੋ",
  snfKg: "ਐਸਐਨਐਫ ਕਿਲੋ",
  fatRate: "FAT ਦਰ",
  snfRate: "SNF ਦਰ",
  baseSNF: "ਬੇਸ SNF",
  totalAmount: "ਕੁੱਲ ਰਕਮ",
  finalAmount: "ਅੰਤਿਮ ਰਕਮ",
  avgFat: "ਔਸਤ FAT",
  avgSnf: "ਔਸਤ SNF",
  totalQuantity: "ਕੁੱਲ ਮਾਤਰਾ",
  totalFat: "ਕੁੱਲ FAT",
  totalSnf: "ਕੁੱਲ SNF",
  totalSolidWeight: "ਕੁੱਲ ਠੋਸ ਭਾਰ",

  // Common
  error: "ਗਲਤੀ",
  success: "ਸਫਲਤਾ",
  confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
  edit: "ਸੋਧੋ",
  delete: "ਹਟਾਓ",
  add: "ਜੋੜੋ",
  update: "ਅਪਡੇਟ ਕਰੋ",
  close: "ਬੰਦ ਕਰੋ",

  // Units
  kg: "ਕਿਲੋ",
  currency: "₹",

  // Messages
  loadingInformation: "ਜਾਣਕਾਰੀ ਲੋਡ ਹੋ ਰਹੀ ਹੈ...",
  loadingDairyInformation: "ਡੇਰੀ ਜਾਣਕਾਰੀ ਲੋਡ ਹੋ ਰਹੀ ਹੈ...",
  loadingUserInformation: "ਉਪਭੋਗਤਾ ਜਾਣਕਾਰੀ ਲੋਡ ਹੋ ਰਹੀ ਹੈ...",
  dairy: "ਡੇਰੀ",
  balance: "ਬੈਲੈਂਸ",
  owner: "ਮਾਲਕ",
  phone: "ਫੋਨ",
  changeType: "ਕਿਸਮ ਬਦਲੋ",
  processing: "ਪ੍ਰੋਸੈਸਿੰਗ...",
  submittingCollections: "ਕਲੈਕਸ਼ਨ ਸਬਮਿਟ ਹੋ ਰਹੇ ਹਨ",
  processingCollections: "{total} ਵਿੱਚੋਂ {current} ਕਲੈਕਸ਼ਨ ਪ੍ਰੋਸੈਸ ਹੋ ਰਹੇ ਹਨ",
  noDataYet: "ਹੁਣ ਤੱਕ ਕੋਈ ਡੇਟਾ ਨਹੀਂ। ਕਲੈਕਸ਼ਨ ਜੋੜਨਾ ਸ਼ੁਰੂ ਕਰਨ ਲਈ 'ਕਤਾਰ ਜੋੜੋ' ਤੇ ਕਲਿਕ ਕਰੋ।",
  loadingRateInformation: "ਦਰ ਦੀ ਜਾਣਕਾਰੀ ਲੋਡ ਹੋ ਰਹੀ ਹੈ...",

  // Footer
  // allRightsReserved: "ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ",
  poweredBy: "ਦੁਆਰਾ ਚਲਾਇਆ ਗਿਆ",

  // Login
  login: "ਲਾਗਇਨ",
  enterPhoneNumber: "ਆਪਣਾ 10 ਅੰਕਾਂ ਦਾ ਫੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ",
  verifyOTP: "OTP ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
  enterOTP: "OTP ਦਰਜ ਕਰੋ",
  changeNumber: "ਨੰਬਰ ਬਦਲੋ",

  // Language Names
  english: "English",
  hindi: "हिन्दी",
  punjabi: "ਪੰਜਾਬੀ",
  kannada: "ಕನ್ನಡ",

  // Bulk Collection
  bulkCollection: "ਥੋਕ ਸੰਗ੍ਰਿਹ",
  prorataBulkCollection: "ਪ੍ਰੋ-ਰਾਟਾ ਥੋਕ ਸੰਗ੍ਰਿਹ",
  prorataViewCollections: "ਪ੍ਰੋ-ਰਾਟਾ ਵਿਊ ਸੰਗ੍ਰਿਹਾਂ",
  bulkCollectionSpreadsheetView: "ਥੋਕ ਸੰਗ੍ਰਿਹ - ਸਪ੍ਰੈਡਸ਼ੀਟ ਵਿਊ",
  backToDashboard: "ਡੈਸ਼ਬੋਰਡ ਤੇ ਵਾਪਸ ਜਾਓ",
  collectionDate: "ਸੰਗ੍ਰਿਹ ਦੀ ਤਾਰੀਖ (ਸਾਰੀਆਂ ਕਤਾਰਾਂ ਲਈ)",
  collectionTime: "ਸੰਗ੍ਰਿਹ ਦਾ ਸਮਾਂ (ਸਾਰੀਆਂ ਕਤਾਰਾਂ ਲਈ)",
  customerManagement: "ਗਾਹਕ ਪ੍ਰਬੰਧਨ",
  rateConfiguration: "ਦਰ ਸੰਰਚਨਾ",
  changeRates: "ਦਰਾਂ ਬਦਲੋ",
  add1Row: "1 ਕਤਾਰ ਜੋੜੋ",
  add5Rows: "5 ਕਤਾਰਾਂ ਜੋੜੋ",
  previewSubmit: "ਪੂਰਵ-ਦਰਸ਼ਨ ਅਤੇ ਜਮ੍ਹਾਂ ਕਰੋ",
  collectionDateEdit: "ਕਲੈਕਸ਼ਨ ਮਿਤੀ",
  collectionTimeEdit: "ਕਲੈਕਸ਼ਨ ਸਮਾਂ",

  // Table Headers
  serialNumber: "#",
  weightKg: "ਭਾਰ (ਕਿਲੋ)",
  fatPercent: "FAT %",
  snfPercent: "SNF %",
  clr: "CLR",
  actions: "ਕਾਰਵਾਈਆਂ",

  // Form Fields
  searchCustomer: "ਗਾਹਕ ਖੋਜੋ",
  rate: "ਦਰ (₹)",

  // Options
  morning: "ਸਵੇਰ",
  evening: "ਸ਼ਾਮ",
  cow: "ਗਾਂ",
  buffalo: "ਮੱਝ",
  cowBuffalo: "ਗਾਂ + ਮੱਝ",

  // Shift Filter Options
  allShifts: "ਸਵੇਰ + ਸ਼ਾਮ",
  morningAm: "ਸਵੇਰ",
  eveningPm: "ਸ਼ਾਮ",

  // Actions
  submitAll: "ਸਭ ਜਮ੍ਹਾਂ ਕਰੋ",

  // New Customer Modal
  name: "ਨਾਮ",
  fatherName: "ਪਿਤਾ ਦਾ ਨਾਮ",
  village: "ਪਿੰਡ",
  address: "ਪਤਾ",
  enterCustomerName: "ਗਾਹਕ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
  enterFatherName: "ਪਿਤਾ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
  enter10DigitPhone: "10-ਅੰਕਾਂ ਦਾ ਫੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ",
  enterVillageName: "ਪਿੰਡ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
  enterCompleteAddress: "ਪੂਰਾ ਪਤਾ ਦਰਜ ਕਰੋ",
  saveCustomer: "ਗਾਹਕ ਸੰਭਾਲੋ",

  // Messages
  noCollectionsAdded: "ਅਜੇ ਤੱਕ ਕੋਈ ਸੰਗ੍ਰਹਿ ਨਹੀਂ ਜੋੜਿਆ ਗਿਆ। ਸੰਗ੍ਰਹਿ ਜੋੜਨ ਲਈ ਹੇਠਾਂ ਦਿੱਤੇ ਬਟਨ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
  collectionSubmittedSuccessfully: "ਸੰਗ੍ਰਹਿ ਸਫਲਤਾਪੂਰਵਕ ਜਮ੍ਹਾਂ ਹੋ ਗਿਆ!",
  collectionsSubmittedSuccessfully: "ਸੰਗ੍ਰਹਿ ਸਫਲਤਾਪੂਰਵਕ ਜਮ੍ਹਾਂ ਹੋ ਗਏ!",
  collectionForCustomerSubmitted: "{customer} ਦਾ ਸੰਗ੍ਰਹਿ ਸਫਲਤਾਪੂਰਵਕ ਜਮ੍ਹਾਂ ਹੋ ਗਿਆ!",
  customerIsRequired: "ਗਾਹਕ ਲਾਜ਼ਮੀ ਹੈ",
  fatPercentIsRequired: "ਚਰਬੀ ਪ੍ਰਤੀਸ਼ਤ ਲਾਜ਼ਮੀ ਹੈ",
  validFatPercentRequired: "ਵੈਧ ਚਰਬੀ ਪ੍ਰਤੀਸ਼ਤ ਲਾਜ਼ਮੀ ਹੈ",
  weightIsRequired: "ਭਾਰ ਲਾਜ਼ਮੀ ਹੈ",
  validWeightRequired: "ਵੈਧ ਭਾਰ ਲਾਜ਼ਮੀ ਹੈ",
  snfPercentIsRequired: "ਐਸਐਨਐਫ ਪ੍ਰਤੀਸ਼ਤ ਲਾਜ਼ਮੀ ਹੈ",
  validSnfPercentRequired: "ਵੈਧ ਐਸਐਨਐਫ ਪ੍ਰਤੀਸ਼ਤ ਲਾਜ਼ਮੀ ਹੈ",
  pleaseAddAtLeastOneCollection: "ਕਿਰਪਾ ਕਰਕੇ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਸੰਗ੍ਰਹਿ ਜੋੜੋ",
  fromCLR: "ਸੀਐਲਆਰ ਤੋਂ",
  noCustomersFound: "ਕੋਈ ਗਾਹਕ ਨਹੀਂ ਮਿਲਿਆ",

  // Placeholders
  egTenPointFive: "ਜਿਵੇਂ 10.5",
  egThreePointFive: "ਜਿਵੇਂ 3.5",
  egTwentySevenPointZero: "ਜਿਵੇਂ 27.0",
  egEightPointFive: "ਜਿਵੇਂ 8.5",
  egFiftyFivePointZero: "ਜਿਵੇਂ 55.0",

  // Preview Collections filters and sorting
  searchCustomerOrId: "ਗਾਹਕ ਦੇ ਨਾਮ ਜਾਂ ਆਈਡੀ ਨਾਲ ਖੋਜੋ",
  filterByCustomer: "ਸਪਲਾਇਰ ਨਾਲ ਖੋਜੋ",
  filterByDate: "ਮਿਤੀ ਨਾਲ ਖੋਜੋ",
  filterByAnimal: "ਪਸ਼ੂ ਅਨੁਸਾਰ ਫਿਲਟਰ",
  allAnimals: "ਸਾਰੇ ਪਸ਼ੂ",
  sortTooltipNewestFirst: "ਤਿਆਰ ਕਰਨ ਦੇ ਸਮੇਂ ਅਨੁਸਾਰ ਨਵਾਂ ਪਹਿਲਾਂ (ਪੁਰਾਣਾ ਪਹਿਲਾਂ ਕਰਨ ਲਈ ਬਦਲੋ)",
  sortTooltipOldestFirst: "ਤਿਆਰ ਕਰਨ ਦੇ ਸਮੇਂ ਅਨੁਸਾਰ ਪੁਰਾਣਾ ਪਹਿਲਾਂ (ਨਵਾਂ ਪਹਿਲਾਂ ਕਰਨ ਲਈ ਬਦਲੋ)",
  sortingLabel: "ਸੋਰਟਿੰਗ:",
  sortingByCreationTime: "ਤਿਆਰ ਕਰਨ ਦੇ ਸਮੇਂ ਅਨੁਸਾਰ",

  // Additional translations for BulkCollectionV1
  lowWalletBalance: "ਘੱਟ ਵਾਲਿਟ ਬੈਲੈਂਸ",
  walletBalanceLowMessage: "ਤੁਹਾਡਾ ਵਾਲਿਟ ਬੈਲੈਂਸ ₹50 ਤੋਂ ਘੱਟ ਹੈ। ਨਿਰੰਤਰ ਸੇਵਾ ਯਕੀਨੀ ਬਣਾਉਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਵਾਲਿਟ ਵਿੱਚ ਪੈਸੇ ਜੋੜੋ।",
  currentBalance: "ਮੌਜੂਦਾ ਬੈਲੈਂਸ",
  dismiss: "ਬੰਦ ਕਰੋ",

  // Pro Rata Collection specific translations

  // Rate Information
  // milkRate: "ਦੁੱਧ ਦੀ ਦਰ (₹)",
  // fatSnf: "ਫੈਟ + ਐਸਐਨਐਫ",
  // fatClr: "ਫੈਟ + ਸੀਐਲਆਰ",
  // litersOnly: "ਸਿਰਫ਼ ਲੀਟਰ",

  // Rate Configuration
  rateChart: "ਦਰ ਚਾਰਟ",
  previewAndSubmit: "ਪੂਰਵ-ਦਰਸ਼ਨ ਅਤੇ ਜਮਾਂ ਕਰੋ",
  noDataYetClickAddRow: "ਅਜੇ ਤੱਕ ਕੋਈ ਡੇਟਾ ਨਹੀਂ ਹੈ। ਕਲੈਕਸ਼ਨ ਜੋੜਨਾ ਸ਼ੁਰੂ ਕਰਨ ਲਈ \"ਕਤਾਰ ਜੋੜੋ\" 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",

  // Customer Management
  addNewCustomer: "ਨਵਾਂ ਸਪਲਾਇਰ ਜੋੜੋ",

  // Collection Form
  animalType: "ਪਸ਼ੂ ਦੀ ਕਿਸਮ",
  mixed: "ਮਿਸ਼ਰਿਤ",

  // Add Money Modal
  topUpWalletInstantly: "ਰੇਜ਼ਰਪੇ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਤੁਰੰਤ ਆਪਣਾ ਵਾਲਿਟ ਟਾਪ ਅਪ ਕਰੋ",
  amountRequired: "ਰਕਮ ਲੋੜੀਂਦੀ ਹੈ",

  // Rate Chart Modal
  fatStepUpRates: "FAT ਸਟੈਪ-ਅਪ ਦਰਾਂ",
  snfStepDownRates: "SNF ਸਟੈਪ-ਡਾਊਨ ਦਰਾਂ",
  rateAppliesWhenFatGreater: "ਇਹ ਦਰ ਤਦ ਲਾਗੂ ਹੁੰਦੀ ਹੈ ਜਦੋਂ FAT% ਸਟੈਪ ਤੋਂ ਜ਼ਿਆਦਾ ਹੋਵੇ",
  rateAppliesWhenSnfLess: "ਇਹ ਦਰ ਤਦ ਲਾਗੂ ਹੁੰਦੀ ਹੈ ਜਦੋਂ SNF% ਸਟੈਪ ਤੋਂ ਘੱਟ ਹੋਵੇ",
  step: "ਸਟੈਪ (%)",
  addStep: "ਸਟੈਪ ਜੋੜੋ",
  fatSnfRatio: "FAT/SNF ਅਨੁਪਾਤ",

  // Change Rates Modal
  baseSNFSetting: "ਬੇਸ ਐਸਐਨਐਫ",
  clrConversionFactor: "ਸੀਐਲਆਰ ਰੂਪਾਂਤਰਣ ਕਾਰਕ",
  selectConversionFactor: "ਸੀਐਲਆਰ ਤੋਂ ਐਸਐਨਐਫ ਫਾਰਮੂਲੇ ਵਿੱਚ ਵਰਤਿਆ ਜਾਣ ਵਾਲਾ ਰੂਪਾਂਤਰਣ ਕਾਰਕ ਚੁਣੋ",

  // New Customer Modal
  fathersName: "ਪਿਤਾ ਦਾ ਨਾਮ",
  newCustomer: "ਨਵਾਂ ਗਾਹਕ",

  // Messages and Alerts
  deleteConfirmation: "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਇਸ ਕਲੈਕਸ਼ਨ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
  confirmDelete: "ਮਿਟਾਉਣਾ ਪੁਸ਼ਟੀ ਕਰੋ",
  pleaseAllowPopups: "ਭੁਗਤਾਨ ਪੂਰਾ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਪਾਪਅਪ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ।",
  paymentLinkOpened: "ਭੁਗਤਾਨ ਲਿੰਕ ਨਵੇਂ ਟੈਬ ਵਿੱਚ ਖੁੱਲ੍ਹਿਆ। ਉੱਥੇ ਭੁਗਤਾਨ ਪੂਰਾ ਕਰੋ।",
  failedToCreatePaymentLink: "ਭੁਗਤਾਨ ਲਿੰਕ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",

  // Bonus Messages
  bonusMessage5Percent: "ਤੁਹਾਨੂੰ ਇਸ ਰੀਚਾਰਜ 'ਤੇ ₹{amount} ਵਾਧੂ ਮਿਲੇਗਾ!",
  bonusMessage10Percent: "ਤੁਹਾਨੂੰ ਇਸ ਰੀਚਾਰਜ 'ਤੇ ₹{amount} ਵਾਧੂ ਮਿਲੇਗਾ!",

  // Success Messages
  rateTypeUpdatedSuccessfully: "ਦਰ ਕਿਸਮ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਹੋ ਗਈ!",
  newCustomerCreatedSuccessfully: "ਨਵਾਂ ਗਾਹਕ {name} ਸਫਲਤਾਪੂਰਵਕ ਬਣਾਇਆ ਗਿਆ!",

  // Error Messages
  someCollectionsHaveInvalidData: "ਕੁਝ ਕਲੈਕਸ਼ਨਾਂ ਵਿੱਚ ਅਵੈਧ ਡੇਟਾ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਫੀਲਡ ਜਾਂਚੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  failedToSubmitCollection: "{customer} ਲਈ ਕਲੈਕਸ਼ਨ ਜਮ੍ਹਾਂ ਕਰਨ ਵਿੱਚ ਅਸਫਲ: {error}",
  failedToUpdateRateType: "ਦਰ ਕਿਸਮ ਅਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  failedToCreateCustomer: "ਗਾਹਕ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",

  // CLR Validation
  clrValueBelowMinimum: "ਸੀਐਲਆਰ ਮੁੱਲ {value} ਘੱਟੋ-ਘੱਟ (13.1) ਤੋਂ ਘੱਟ ਹੈ",
  clrValueAboveMaximum: "ਸੀਐਲਆਰ ਮੁੱਲ {value} ਵੱਧ ਤੋਂ ਵੱਧ (34.0) ਤੋਂ ਜ਼ਿਆਦਾ ਹੈ",

  // Preview Collections Modals
  confirmDeleteCollection: "ਮਿਟਾਉਣਾ ਪੁਸ਼ਟੀ ਕਰੋ",
  areYouSureDeleteCollection: "ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਇਸ ਕਲੈਕਸ਼ਨ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
  deleting: "ਮਿਟਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...",
  deleteSuccess: "ਕਲੈਕਸ਼ਨ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾ ਦਿੱਤੀ ਗਈ",
  collectionDeletedSuccessfully: "ਕਲੈਕਸ਼ਨ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾ ਦਿੱਤੀ ਗਈ!",
  deleteFailed: "ਕਲੈਕਸ਼ਨ ਮਿਟਾਉਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  loadCollectionsFailed: "ਕਲੈਕਸ਼ਨਾਂ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  loadCustomersFailed: "ਗਾਹਕਾਂ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",

  // Bulk Update Modal
  bulkUpdateRateBaseSnf: "ਦੁੱਧ ਅਤੇ ਬੇਸ SNF ਅਪਡੇਟ ਕਰੋ",
  allDates: "ਸਾਰੀਆਂ ਤਾਰੀਖ਼ਾਂ",
  newMilkRatePerKg: "ਨਵੀਂ ਦੁੱਧ ਦਰ (₹/ਕਿਲੋ):",
  newBaseSnfPercent: "ਨਵਾਂ ਬੇਸ SNF (%):",

  // Milk Rate Preview Modal
  previewMilkRateCalculations: "ਦੁੱਧ ਦਰ ਗਣਨਾ ਦਾ ਪੂਰਵਝਲਕ",
  collectionsOnDate: "{date} ਨੂੰ ਕਲੈਕਸ਼ਨਾਂ",
  collectionsFromToDate: "{fromDate} ਤੋਂ {toDate} ਤੱਕ ਕਲੈਕਸ਼ਨਾਂ",
  dateAndTime: "ਤਾਰੀਖ਼ ਅਤੇ ਸਮਾਂ",
  baseSnfPercent: "ਬੇਸ SNF",

  pleaseReviewBeforeSave: "ਕਿਰਪਾ ਕਰਕੇ ਸੇਵ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਸੰਪਾਦਿਤ ਕਲੈਕਸ਼ਨ ਦੀ ਸਮੀਖਿਆ ਕਰੋ:",

  // Filter Modal
  filterCollectionsMilkRateUpdate: "ਦੁੱਧ ਦਰ ਅਪਡੇਟ ਲਈ ਕਲੈਕਸ਼ਨਾਂ ਫਿਲਟਰ ਕਰੋ",
  dateRangeLabel: "ਤਾਰੀਖ਼ ਸੀਮਾ",

  // Customer Selection Modal

  // Bulk Update Confirmation Modal
  confirmBulkUpdate: "ਬਲਕ ਅਪਡੇਟ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
  areYouSureApplyBulkChanges: "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਇਹ ਬਲਕ ਤਬਦੀਲੀਆਂ ਲਾਗੂ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
  collectionsToUpdate: "ਅਪਡੇਟ ਕਰਨ ਲਈ ਕਲੈਕਸ਼ਨ",
  newMilkRate: "ਨਵੀਂ ਦੁੱਧ ਦਰ (₹/ਕਿਲੋ)",
  newBaseSnf: "ਨਵਾਂ ਬੇਸ SNF",
  newSnfPercentage: "ਨਵਾਂ SNF ਪ੍ਰਤੀਸ਼ਤ",
  newClr: "ਨਵਾਂ CLR",
  updatingCollectionsCount: "{count} ਸੰਗ੍ਰਹਿਆਂ ਨੂੰ ਅਪਡੇਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
  newRate: "ਨਵੀਂ ਦਰ",
  newAmount: "ਨਵੀਂ ਰਕਮ",
  confirmAndUpdate: "ਪੁਸ਼ਟੀ ਕਰੋ ਅਤੇ ਅਪਡੇਟ ਕਰੋ",

  // Final Submit Confirmation Modal
  importantConfirmation: "ਮਹੱਤਵਪੂਰਨ ਪੁਸ਼ਟੀ",
  irreversibleChangesWarning: "ਅਟੱਲ ਤਬਦੀਲੀ ਚੇਤਾਵਨੀ",
  pleaseBeAware: "ਕਿਰਪਾ ਕਰਕੇ ਜਾਣੋ:",
  irreversibleChangesWarningText: "ਜਦੋਂ ਤੁਸੀਂ ਸਬਮਿਟ ਬਟਨ 'ਤੇ ਕਲਿਕ ਕਰੋਗੇ, ਇਹ ਤਬਦੀਲੀਆਂ ਨੂੰ ਪਿਛਲੀ ਸਥਿਤੀ ਵਿੱਚ ਵਾਪਸ ਨਹੀਂ ਲਿਆ ਜਾ ਸਕਦਾ। ਸਾਰੇ ਪ੍ਰਭਾਵਿਤ ਸੰਗ੍ਰਹਿ ਨਵੇਂ ਮੁੱਲਾਂ ਨਾਲ ਸਥਾਈ ਤੌਰ 'ਤੇ ਅਪਡੇਟ ਕੀਤੇ ਜਾਣਗੇ।",
  areYouAbsolutelySureYouWantToProceed: "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਅੱਗੇ ਜਾਣਾ ਚਾਹੁਂਦੇ ਹੋ?",
  submitChanges: "ਤਬਦੀਲੀਆਂ ਸਬਮਿਟ ਕਰੋ",

  // Report Types
  fullReport: "ਪੂਰੀ ਰਿਪੋਰਟ",
  purchaseReportDayWise: "ਖਰੀਦ ਰਿਪੋਰਟ - ਦਿਨ ਅਨੁਸਾਰ",
  purchaseSummarySupplierWise: "ਖਰੀਦ ਸਾਰਾਂਸ਼ - ਸਪਲਾਇਰ ਅਨੁਸਾਰ",
  allSupplierBill: "ਸਭ ਸਪਲਾਇਰ ਬਿਲ",
  supplierBillsPro: "ਸਪਲਾਇਰ ਬਿਲ (ਪ੍ਰੋ-ਰਾਟਾ)",
  supplierBills: "ਸਪਲਾਇਰ ਬਿਲ",

  // Pro-Rata Report Types
  fullReportPro: "ਪੂਰੀ ਰਿਪੋਰਟ (ਪ੍ਰੋ-ਰਾਟਾ)",
  purchaseReportDayWisePro: "ਖਰੀਦ ਰਿਪੋਰਟ - ਦਿਨ ਅਨੁਸਾਰ (ਪ੍ਰੋ-ਰਾਟਾ)",
  purchaseSummarySupplierWisePro: "ਖਰੀਦ ਸਾਰਾਂਸ਼ - ਸਪਲਾਇਰ ਅਨੁਸਾਰ (ਪ੍ਰੋ-ਰਾਟਾ)",
  allSupplierBillPro: "ਸਭ ਸਪਲਾਇਰ ਬਿਲ (ਪ੍ਰੋ-ਰਾਟਾ)",
  supplierBillsPro: "ਸਪਲਾਇਰ ਬਿਲ (ਪ੍ਰੋ-ਰਾਟਾ)",
  viewCompleteCollectionReport: "ਪੂਰੀ ਕਲੈਕਸ਼ਨ ਰਿਪੋਰਟ ਵੇਖੋ",
  viewCollectionsByDate: "ਤਾਰੀਖ ਅਨੁਸਾਰ ਕਲੈਕਸ਼ਨ ਵੇਖੋ",
  viewCollectionsAsPerSupplier: "ਸਪਲਾਇਰ ਅਨੁਸਾਰ ਕਲੈਕਸ਼ਨ ਵੇਖੋ",
  viewComprehensiveSupplierBills: "ਵਿਆਪਕ ਸਪਲਾਇਰ ਬਿਲ ਵੇਖੋ",
  viewIndividualSupplierBills: "ਵਿਅਕਤੀਗਤ ਸਪਲਾਇਰ ਬਿਲ ਵੇਖੋ",

  // Additional Labels
  fromDate: "ਤੋਂ ਤਾਰੀਖ",
  toDate: "ਤੱਕ ਤਾਰੀਖ",
  selectReportType: "ਰਿਪੋਰਟ ਕਿਸਮ ਚੁਣੋ",
  selectReportTypeProRata: "ਰਿਪੋਰਟ ਕਿਸਮ ਚੁਣੋ (ਪ੍ਰੋ-ਰਾਟਾ)",
  generateReport: "ਰਿਪੋਰਟ ਬਣਾਓ",
  generating: "ਬਣਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...",
  pleaseSelectBothStartAndEndDates: "ਕਿਰਪਾ ਕਰਕੇ ਸ਼ੁਰੂ ਅਤੇ ਅੰਤ ਦੋਵੇਂ ਤਾਰੀਖਾਂ ਚੁਣੋ",
  invalidReportTypeSelected: "ਗਲਤ ਰਿਪੋਰਟ ਕਿਸਮ ਚੁਣੀ ਗਈ",
  failedToGenerateReport: "ਰਿਪੋਰਟ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ",
  failedToLoadSuppliers: "ਸਪਲਾਇਰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
  failedToUpdateSupplierInformation: "ਸਪਲਾਇਰ ਜਾਣਕਾਰੀ ਅਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
  pleaseSelectDateRangeForReport: "ਰਿਪੋਰਟ ਲਈ ਤਾਰੀਖ ਸੀਮਾ ਚੁਣੋ",
  noDataFoundForTheSelectedSupplierInTheSelectedDateRange: "ਚੁਣੀ ਗਈ ਤਾਰੀਖ ਸੀਮਾ ਵਿੱਚ ਚੁਣੇ ਗਏ ਸਪਲਾਇਰ ਲਈ ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਮਿਲਿਆ",
  failedToGenerateSupplierReport: "ਸਪਲਾਇਰ ਰਿਪੋਰਟ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ",
  failedToGenerateProRataSupplierReport: "ਪ੍ਰੋ-ਰਾਟਾ ਸਪਲਾਇਰ ਰਿਪੋਰਟ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ",

  // Month Names
  january: "ਜਨਵਰੀ",
  february: "ਫਰਵਰੀ",
  march: "ਮਾਰਚ",
  april: "ਅਪ੍ਰੈਲ",
  may: "ਮਈ",
  june: "ਜੂਨ",
  july: "ਜੁਲਾਈ",
  august: "ਅਗਸਤ",
  september: "ਸਤੰਬਰ",
  october: "ਅਕਤੂਬਰ",
  november: "ਨਵੰਬਰ",
  december: "ਦਸੰਬਰ",

  // Additional missing keys
  includeMilkRateBRateColumn: "ਦੁੱਧ ਦਰ (ਬੀ-ਰੇਟ) ਕਾਲਮ ਸ਼ਾਮਲ ਕਰੋ",
  backToReportSelection: "ਰਿਪੋਰਟ ਚੋਣ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  databaseId: "ਡਾਟਾਬੇਸ ਆਈਡੀ",
  customerId: "ਗਾਹਕ ਆਈਡੀ",
  supplierID: "ਸਪਲਾਇਰ ਆਈਡੀ",
  notSpecified: "ਨਿਰਦਿਸ਼ਤ ਨਹੀਂ",
  id: "ਆਈਡੀ",

  // Warning and Success Messages
  milkRateUpdatedSuccessfully: "ਦੁੱਧ ਦੀ ਦਰ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਹੋਈ!",
  errorSavingMilkRatePleaseTryAgain: "ਦੁੱਧ ਦੀ ਦਰ ਸੇਵ ਕਰਨ 'ਚ ਗਲਤੀ। ਕਿਰਪਾ ਪੁਨਃ ਪ੍ਰਯਤਨਿਸ ਕਰੋ।",
  errorSavingMilkRateAndRateSettingsPleaseTryAgain: "ਦੁੱਧ ਦੀ ਦਰ ਅਤੇ ਦਰ ਸੈਟਿੰਗਸ ਸੇਵ ਕਰਨ 'ਚ ਗਲਤੀ। ਕਿਰਪਾ ਪੁਨਃ ਪ੍ਰਯਤਨਿਸ ਕਰੋ।",
  rateChartLoadedSuccessfully: "ਦਰ ਚਾਰਟ ਸਫਲਤਾਪੂਰਵਕ ਲੋਡ ਹੋਇਆ",
  paymentLinkOpenedInNewTabCompletePaymentThere: "ਭੁਗਤਾਨ ਲਿੰਕ ਨਵੇਂ ਟੈਬ 'ਚ ਖੁਲ੍ਹਾ ਗਿਆ। ਉੱਥੇ ਭੁਗਤਾਨ ਪੂਰਾ ਕਰੋ।",
  paymentSuccessfulYourWalletWillBeUpdatedShortly: "✅ ਭੁਗਤਾਨ ਸਫਲ! ਤੁਹਾਡੇ ਵੇਲਟ ਜਲਦ ਹੀ ਅਪਡੇਟ ਹੋਵੇਗਾ।",
  individualMilkRateSavedSuccessfullyProRataCollection: "ਵਿਅਕਤੀਗਤ ਦੁੱਧ ਦਰ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਹੋਈ (ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ)",
  bulkEditCollections: "ਬਲਕ ਸੰਪਾਦਨ ਕਲੈਕਸ਼ਨ",
  collectionsOn: "ਕਲੈਕਸ਼ਨ ਦਿਨਾਂਕ",
  collectionsFromTo: "ਕਲੈਕਸ਼ਨ {fromDate} ਤੋਂ {toDate} ਤੱਕ",
  items: "ਆਈਟਮ",
  clrConversion: "CLR ਰੂਪਾਂਤਰਣ",
  mix: "ਮਿਕਸ",
  fat: "Fat",
  snf: "SNF",
  solid: "ਠੋਸ",
  finalAmt: "ਅੰਤਿਮ ਰਾਸ਼ੀ",
  applyBulkChanges: "ਬਲਕ ਤਬਦੀਲੀਆਂ ਲਾਗੂ ਕਰੋ",

  // Dairy & Owner Information Card
  dairyAndOwnerInfo: "ਡੇਅਰੀ ਅਤੇ ਮਾਲਕ ਦੀ ਜਾਣਕਾਰੀ",
  yourDairyAndContactDetails: "ਤੁਹਾਡੀ ਡੇਅਰੀ ਅਤੇ ਸੰਪਰਕ ਵੇਰਵਾ",
  ownerName: "ਮਾਲਕ ਦਾ ਨਾਂ",

  // Pro Rata Collection Component
  proRata: "ਪ੍ਰੋ ਰਾਟਾ",
  set: "ਸੈਟ ਕਰੋ",
  status: "ਸਥਿਤੀ",
  setTheRateChart: "ਰੇਟ ਚਾਰਟ ਸੈਟ ਕਰੋ",
  fatStepUp: "Fat ਸਟੈਪ-ਅੱਪ",
  snfStepDown: "SNF ਸਟੈਪ-ਡਾਊਨ",
  notConfigured: "ਕੌਂਫਿਗਰ ਨਹੀਂ ਕੀਤਾ",
  proRataStatus: "ਪ੍ਰੋ-ਰਾਟਾ ਸਥਿਤੀ",
  active: "ਸਰਗਰਮ",
  rateChartRequired: "ਰੇਟ ਚਾਰਟ ਲਾਜ਼ਮੀ",
  pleaseSetUpYourRateChartFirst: "ਕਿਰਪਾ ਕਰਕੇ ਸੰਗ੍ਰਹ ਜੋੜਨ ਤੋਂ ਪਹਿਲਾਂ ਆਪਣਾ ਰੇਟ ਚਾਰਟ ਸੈਟ ਕਰੋ। ਇਹ ਠੀਕ ਪ੍ਰੋ-ਰਾਟਾ ਗਣਨਾ ਲਈ ਲਾਜ਼ਮੀ ਹੈ।",
  setUpRateChart: "ਰੇਟ ਚਾਰਟ ਸੈਟ ਕਰੋ",

  // Edit Collection Modal Labels
  editCollection: "ਸੰਗ੍ਰਹ ਸੰਪਾਦਿਤ ਕਰੋ",
  supplier: "ਸਪਲਾਇਰ",
  select: "ਚੁਣੋ",
  previewChanges: "ਤਬਦੀਲੀਆਂ ਵੇਖੋ",
  backToEdit: "ਸੰਪਾਦਨ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  confirmSave: "ਪੁਸ਼ਟੀ ਕਰੋ ਅਤੇ ਸੰਭਾਲੋ",

  // Edit Supplier Modal
  selectSupplierPro: "ਸਪਲਾਈਅਰ ਚੁਣੋ (ਪ੍ਰੋ-ਰਾਟਾ)",
  selectSupplier: "ਸਪਲਾਈਅਰ ਚੁਣੋ ",

  editSupplier: "ਸਪਲਾਈਅਰ ਸੰਪਾਦਿਤ ਕਰੋ",
  searchSuppliers: "ਸਪਲਾਈਅਰ ਖੋਜੋ...",
  enterSupplierName: "ਸਪਲਾਈਅਰ ਦਾ ਨਾਮ ਦਾਖਲ ਕਰੋ",
  backToList: "ਸੂਚੀ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  updateSupplier: "ਸਪਲਾਈਅਰ ਅਪਡੇਟ ਕਰੋ",

  // Supplier Details Modal
  supplierInformation: "ਸਪਲਾਈਅਰ ਜਾਣਕਾਰੀ",
  editSupplierInfo: "ਪੂਰਤੀਕਰਤਾ ਜਾਣਕਾਰੀ ਸੰਪਾਦਤ ਕਰੋ",
  downloadReport: "ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
  proRataCollectionsModal: "ਪ੍ਰੋ ਰਾਟਾ ਕਲੈਕਸ਼ਨ",
  // Excel Table Headers
  // Customer Search Dropdown
  noId: "ਕੋਈ ID ਨਹੀਂ",
  loadMore: "ਹੋਰ ਲੋਡ ਕਰੋ",
  retry: "ਫਿਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
  thisBulkUpdateCannotBeUndone: "ਇਹ ਕਾਰਵਾਈ ਪਹਿਲਾਂ ਵਾਪਸ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ।",
  thisActionCannotBeUndone: "ਚੇਤਾਵਨੀ: ਇਹ ਕਾਰਵਾਈ ਸਥਾਈ ਹੈ ਅਤੇ ਇਸਨੂੰ ਵਾਪਸ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ।",
  confirmDeletion: "ਹਟਾਉਣ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
  addNewSupplier: "ਨਵਾਂ ਸਪਲਾਈਅਰ ਜੋੜੋ",
  // Pro-rata Calculation Note
  proRataCalculationNote: "* ਪ੍ਰੋ-ਰਾਟਾ ਗਣਨਾ ਜਦੋਂ ਵਸਾ% > 6.5 ਹੋਵੇ. ਦਰ ਫਾਰਮੂਲਾ: ਬੇਸ ਦਰ + ((ਵਸਾ%-6.5)×{fatStepUpRate}) + ((SNF%-9)×{snfStepDownRate})",
  fatSnfRatioNote: "Fat/SNF ਅਨੁਪਾਤ: {ratio} - Fat ਦਰ ਦੀ ਗਣਨਾ ਲਈ ({fatPercent}% ਦਰ / 6.5) ਅਤੇ SNF ਦਰ ਦੀ ਗਣਨਾ ਲਈ ({snfPercent}% ਦਰ / ਬੇਸ SNF) ਵਰਤਿਆ ਜਾਂਦਾ ਹੈ",
  // Rate Change Modal
  configureYourMilkCalculationParameters: "ਆਪਣੇ ਦੁੱਧ ਗਣਨਾ ਪੈਰਾਮੀਟਰਾਂ ਨੂੰ ਕੌਂਫਿਗਰ ਕਰੋ",
  changeMilkRate: "ਦੁੱਧ ਦਰ ਬਦਲੋ",
  enterNewMilkRate: "ਨਵਾਂ ਦੁੱਧ ਦਰ ਦਾਖਲ ਕਰੋ",
  updateRate: "ਦਰ ਅਪਡੇਟ ਕਰੋ",
  // Customer Dropdown and Table Headers
  shift: "ਸ਼ਿਫਟ",
  animal: "ਜਾਨਵਰ",
  litersOnly: "ਲੀਟਰ",
  apply: "ਲਾਗੂ ਕਰੋ",

  // Active Filters Summary
  activeFilters: "ਸਰਗਰਮ ਫਿਲਟਰ:",
  showingCollectionsFor: "{name} ਲਈ ਭੰਡਾਰ ਦਿਖਾ ਰਹੇ ਹਨ",
  showingCollectionsForOn: "{name} ਲਈ {date} ਨੂੰ ਭੰਡਾਰ ਦਿਖਾ ਰਹੇ ਹਨ",
  showingCollectionsForFromTo: "{name} ਲਈ {fromDate} ਤੋਂ {toDate} ਤੱਕ ਭੰਡਾਰ ਦਿਖਾ ਰਹੇ ਹਨ",
  showingAllCollectionsOn: "ਸਾਰੇ ਭੰਡਾਰ {date} ਨੂੰ ਦਿਖਾ ਰਹੇ ਹਨ",
  showingAllCollectionsFromTo: "ਸਾਰੇ ਭੰਡਾਰ {fromDate} ਤੋਂ {toDate} ਤੱਕ ਦਿਖਾ ਰਹੇ ਹਨ",
  sorting: "ਲੜੀਬੱਧ:",
  clearSupplier: "ਸਪਲਾਇਰ ਹਟਾਓ",
  clearDates: "ਮਿਤੀਆਂ ਹਟਾਓ",

  // Offers Modal
  starterBonusRange: "₹500 - ₹999",
  premiumBonusRange: "₹1000+",
  getExtraBonusOnRecharge: "ਰੀਚਾਰਜ 'ਤੇ ਵਾਧੂ ਬੋਨਸ ਪ੍ਰਾਪਤ ਕਰੋ",
  getExtra5PercentBonus: "ਵਾਧੂ 5% ਬੋਨਸ ਪ੍ਰਾਪਤ ਕਰੋ",
  addBetween500And999: "₹500 - ₹999 ਦੇ ਰੀਚਾਰਜ 'ਤੇ",
  getExtra10PercentBonus: "ਵਾਧੂ 10% ਬੋਨਸ ਪ੍ਰਾਪਤ ਕਰੋ",
  add1000OrMore: "₹1000 ਜਾਂ ਇਸ ਤੋਂ ਵੱਧ ਦੇ ਰੀਚਾਰਜ 'ਤੇ",

  // Support Modal
  contactSupport: "ਸੰਪਰਕ ਸਹਾਇਤਾ",
  whatsappSupport: "ਵਟਸਐਪ ਸਹਾਇਤਾ",
  callSupport: "ਕਾਲ ਸਹਾਇਤਾ",
  supportNumber: "+91 7454 860 294",

  // Bulk Collection Support Section
  havingTroubleAddingMoney: "ਪੈਸੇ ਸ਼ਾਮਲ ਕਰਨ ਵਿੱਚ ਮੁਸ਼ਕਲ ਆ ਰਹੀ ਹੈ?",
  contactUs: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",

  // Offers Support Section
  needHelpWithOffers: "ਆਫਰਾਂ ਬਾਰੇ ਮਦਦ ਚਾਹੀਦੀ ਹੈ?",

  // Navbar Support Button
  support: "ਸਹਾਇਤਾ",

  // Toast Messages for Pro-Rata Collections
  collectionUpdatedSuccessfully: "ਕਲੈਕਸ਼ਨ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ!",
  updatedProRataCollectionsWithMilkRate: "{successful} ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ ਦੁੱਧ ਦਰ ਨਾਲ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ। {failed} ਕਲੈਕਸ਼ਨ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
  successfullyUpdatedProRataCollectionsWithMilkRate: "{count} ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ ਦੁੱਧ ਦਰ {rate} ਨਾਲ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ।",
  successfullyUpdatedProRataCollections: "{count} ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ।",
  noProRataCollectionsFoundToUpdate: "ਅੱਪਡੇਟ ਕਰਨ ਲਈ ਕੋਈ ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ ਨਹੀਂ ਮਿਲਿਆ।",
  failedToApplyMilkRatesAndBaseSnf: "ਦੁੱਧ ਦਰ ਅਤੇ ਬੇਸ SNF ਲਾਗੂ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  failedToUpdateCollections: "ਕਲੈਕਸ਼ਨ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  failedToLoadCustomers: "ਗਾਹਕਾਂ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  pleaseSelectDate: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਤਾਰੀਖ ਚੁਣੋ",
  pleaseSelectBothFromAndToDates: "ਕਿਰਪਾ ਕਰਕੇ ਦੋਵੇਂ ਸ਼ੁਰੂਆਤੀ ਅਤੇ ਅੰਤਿਮ ਤਾਰੀਖਾਂ ਚੁਣੋ",
  toDateCannotBeEarlierThanFromDate: "ਅੰਤਿਮ ਤਾਰੀਖ ਸ਼ੁਰੂਆਤੀ ਤਾਰੀਖ ਤੋਂ ਪਹਿਲਾਂ ਨਹੀਂ ਹੋ ਸਕਦੀ",

  // Validation Error Messages
  customerNameRequired: "ਗਾਹਕ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
  collectionDateRequired: "ਕਲੈਕਸ਼ਨ ਤਾਰੀਖ ਲੋੜੀਂਦੀ ਹੈ",
  fatPercentRequired: "ਫੈਟ ਪ੍ਰਤੀਸ਼ਤ ਲੋੜੀਂਦੀ ਹੈ",
  fatPercentCannotExceed15: "ਫੈਟ ਪ੍ਰਤੀਸ਼ਤ 15% ਤੋਂ ਵੱਧ ਨਹੀਂ ਹੋ ਸਕਦੀ",
  weightRequired: "ਭਾਰ ਲੋੜੀਂਦਾ ਹੈ",
  snfPercentRequired: "SNF ਪ੍ਰਤੀਸ਼ਤ ਲੋੜੀਂਦੀ ਹੈ",
  snfPercentCannotExceed15: "SNF ਪ੍ਰਤੀਸ਼ਤ 15% ਤੋਂ ਵੱਧ ਨਹੀਂ ਹੋ ਸਕਦੀ",
  validClrRequired: "ਵੈਧ CLR ਲੋੜੀਂਦਾ ਹੈ",

  // Customer Validation Error Messages
  customerNotFoundInSystem: "ਗਾਹਕ ਸਿਸਟਮ ਵਿੱਚ ਨਹੀਂ ਮਿਲਿਆ",
  pleaseSelectValidCustomerBeforeContinuing: "ਕਿਰਪਾ ਕਰਕੇ ਜਾਰੀ ਰੱਖਣ ਤੋਂ ਪਹਿਲਾਂ ਇੱਕ ਵੈਧ ਗਾਹਕ ਚੁਣੋ",
  failedToVerifyCustomer: "ਗਾਹਕ ਨੂੰ ਤਸਦੀਕ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  customerSelectionIsRequired: "ਗਾਹਕ ਚੋਣ ਲੋੜੀਂਦੀ ਹੈ",
  pleaseSelectValidCustomerBeforeSaving: "ਕਿਰਪਾ ਕਰਕੇ ਸੇਵ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਇੱਕ ਵੈਧ ਗਾਹਕ ਚੁਣੋ",
  pleaseEnterValidMilkRate: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਦੁੱਧ ਦਰ ਦਾਖਲ ਕਰੋ",
  noProRataCollectionsFoundForSelectedDateRange: "ਚੁਣੀ ਗਈ ਤਾਰੀਖ ਸੀਮਾ ਲਈ ਕੋਈ ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ ਨਹੀਂ ਮਿਲਿਆ",
  // Table Headers
  sNo: "ਕ੍ਰ.ਸੰ.",
  dateAndShift: "ਤਾਰੀਖ ਅਤੇ ਸ਼ਿਫਟ",
  date: "ਤਾਰੀਖ",
  name: "ਨਾਮ",
  qtyKg: "ਮਾਤਰਾ (ਕਿਗ੍ਰਾ)",
  fatPercent: "ਫੈਟ %",
  snfPercent: "SNF %",
  clr: "CLR",
  fatKg: "ਫੈਟ (ਕਿਗ੍ਰਾ)",
  snfKg: "SNF (ਕਿਗ੍ਰਾ)",
  fatRate: "ਫੈਟ ਦਰ",
  snfRate: "SNF ਦਰ",
  fatStepUp: "ਫੈਟ ਸਟੈਪ ਅਪ",
  snfStepDown: "SNF ਸਟੈਪ ਡਾਊਨ",
  bRate: "B ਦਰ",
  rate: "ਦਰ",
  milkRate: "ਦੁੱਧ ਦਰ",
  baseSnf: "ਬੇਸ SNF",
  amount: "ਰਕਮ",
  actions: "ਕਾਰਵਾਈ",
  failedToLoadProRataCollectionsForPreview: "ਪ੍ਰੀਵਿਊ ਲਈ ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",

  // Bulk Update Error Messages
  pleaseEnterAtLeastOneValueToUpdate: "ਕਿਰਪਾ ਕਰਕੇ ਅੱਪਡੇਟ ਕਰਨ ਲਈ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਮੁੱਲ ਦਾਖਲ ਕਰੋ",
  noCollectionsFoundToUpdate: "ਅੱਪਡੇਟ ਕਰਨ ਲਈ ਕੋਈ ਕਲੈਕਸ਼ਨ ਨਹੀਂ ਮਿਲਿਆ",

  // Bulk Update Result Messages
  collectionReachedMaximumEditLimit: "ਕਲੈਕਸ਼ਨ {id} ਅਧਿਕਤਮ ਸੰਪਾਦਨ ਸੀਮਾ ਤੱਕ ਪਹੁੰਚ ਗਿਆ ਹੈ ({message})",
  failedToUpdateCollection: "ਕਲੈਕਸ਼ਨ {id} ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ: {message}",
  bulkUpdateFailed: "ਬਲਕ ਅੱਪਡੇਟ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  collectionReachedMaximumEditLimitWithCount: "ਕਲੈਕਸ਼ਨ {id} ਅਧਿਕਤਮ ਸੰਪਾਦਨ ਸੀਮਾ ਤੱਕ ਪਹੁੰਚ ਗਿਆ ਹੈ ({editCount}/2)",
  invalidCollectionSelectedForDeletion: "ਹਟਾਉਣ ਲਈ ਅਵੈਧ ਕਲੈਕਸ਼ਨ ਚੁਣਿਆ ਗਿਆ",
  updatedCollectionsWithMilkRatePartially: "{successful} ਕਲੈਕਸ਼ਨ ਦੁੱਧ ਦਰ ਨਾਲ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ। {failed} ਕਲੈਕਸ਼ਨ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
  successfullyUpdatedCollectionsWithMilkRate: "{count} ਕਲੈਕਸ਼ਨ ਦੁੱਧ ਦਰ {rate} ਨਾਲ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ।",
  successfullyUpdatedCollections: "{count} ਕਲੈਕਸ਼ਨ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ।",
  successfullyUpdatedProRataCollectionsWithRateChart: "{count} ਪ੍ਰੋ-ਰਾਟਾ ਕਲੈਕਸ਼ਨ ਰੇਟ ਚਾਰਟ ਨਾਲ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ।",
  noCollectionsWereUpdated: "ਕੋਈ ਕਲੈਕਸ਼ਨ ਅੱਪਡੇਟ ਨਹੀਂ ਕੀਤੇ ਗਏ। ਕਿਰਪਾ ਕਰਕੇ ਜਾਂਚੋ ਕਿ ਕਲੈਕਸ਼ਨ ਮੌਜੂਦ ਹਨ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  rateChartFunctionalityWillBeImplementedSoon: "ਦਰ ਚਾਰਟ ਕਾਰਜਕੁਸ਼ਲਤਾ ਜਲਦ ਹੀ ਲਾਗੂ ਕੀਤੀ ਜਾਵੇਗੀ",
  pleaseEnterAValidMilkRate: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਦੁੱਧ ਦਰ ਦਾਖਲ ਕਰੋ",
  noCollectionsFoundForTheSelectedDateRange: "ਚੁਣੀ ਗਈ ਤਾਰੀਖ ਸੀਮਾ ਲਈ ਕੋਈ ਕਲੈਕਸ਼ਨ ਨਹੀਂ ਮਿਲਿਆ",
  noStandardCollectionsFoundInDateRange: "ਚੁਣੀ ਗਈ ਤਾਰੀਖ ਸੀਮਾ ਵਿੱਚ ਕੋਈ ਸਟੈਂਡਰਡ ਕਲੈਕਸ਼ਨ ਨਹੀਂ ਮਿਲਿਆ",
  failedToLoadCollectionsForPreview: "ਪ੍ਰੀਵਿਊ ਲਈ ਕਲੈਕਸ਼ਨ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  pleaseSelectADateForFilter: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਤਾਰੀਖ ਚੁਣੋ",
  errorFixingReportAmounts: "❌ ਰਿਪੋਰਟ ਰਾਸ਼ੀਆਂ ਠੀਕ ਕਰਨ ਵਿੱਚ ਗਲਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  errorSavingRateSettings: "ਦਰ ਸੈਟਿੰਗਾਂ ਸੇਵ ਕਰਨ ਵਿੱਚ ਗਲਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  snfStepMustBeBetween7And12: "SNF ਸਟੈਪ 7% ਅਤੇ 12% ਦੇ ਵਿਚਕਾਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
  snfStepMustBeLessThanPreviousSteps: "SNF ਸਟੈਪ ਪਿਛਲੇ ਸਟੈਪਾਂ ਤੋਂ ਘੱਟ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
  fatStepCannotBeGreaterThan12: "ਫੈਟ ਸਟੈਪ 12% ਤੋਂ ਵੱਧ ਨਹੀਂ ਹੋ ਸਕਦਾ",
  fatStepMustBeGreaterThanPreviousSteps: "ਫੈਟ ਸਟੈਪ ਪਿਛਲੇ ਸਟੈਪਾਂ ਤੋਂ ਵੱਧ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",

  // Rate Chart Messages
  rateChartSavedSuccessfully: "ਰੇਟ ਚਾਰਟ ਸਫਲਤਾਪੂਰਵਕ ਸੇਵ ਕੀਤਾ ਗਿਆ!",
  errorSavingRateChart: "ਰੇਟ ਚਾਰਟ ਸੇਵ ਕਰਨ ਵਿੱਚ ਗਲਤੀ: {message}",
  errorSavingFatSnfRatio: "FAT/SNF ਅਨੁਪਾਤ ਸੇਵ ਕਰਨ ਵਿੱਚ ਗਲਤੀ:",

  // Dairy Logo
  dairyLogo: "ਡੇਅਰੀ ਲੋਗੋ",
  logoNotSet: "ਕੋਈ ਲੋਗੋ ਸੈੱਟ ਨਹੀਂ ਹੈ",
  logoUpload: "ਲੋਗੋ ਅੱਪਲੋਡ ਕਰੋ",
  logoReplace: "ਲੋਗੋ ਬਦਲੋ",
  logoRemove: "ਲੋਗੋ ਹਟਾਓ",
  logoSelectFile: "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਲੋਗੋ ਫਾਈਲ ਚੁਣੋ।",
  logoMustBePngJpgWebp: "ਲੋਗੋ PNG, JPG, ਜਾਂ WebP ਚਿੱਤਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
  logoMustBe2MbOrSmaller: "ਲੋਗੋ 2 MB ਜਾਂ ਇਸ ਤੋਂ ਛੋਟਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
  logoUploadValidImage: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ PNG, JPG, ਜਾਂ WebP ਚਿੱਤਰ ਅੱਪਲੋਡ ਕਰੋ।",
  logoHint: "ਤੁਹਾਡਾ ਲੋਗੋ ਹਰ PDF ਰਿਪੋਰਟ ਦੇ ਉੱਪਰੀ-ਖੱਬੇ ਕੋਨੇ ਵਿੱਚ ਦਿਖਾਈ ਦੇਵੇਗਾ। PNG, JPG, ਜਾਂ WebP, ਵੱਧ ਤੋਂ ਵੱਧ 2 MB।",
  logoUpdatedSuccessfully: "ਲੋਗੋ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਹੋ ਗਿਆ!",
  logoRemovedSuccessfully: "ਲੋਗੋ ਸਫਲਤਾਪੂਰਵਕ ਹਟਾ ਦਿੱਤਾ ਗਿਆ!",
  logoUploadFailed: "ਲੋਗੋ ਅੱਪਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  logoRemoveFailed: "ਲੋਗੋ ਹਟਾਉਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  logoRemoveConfirmMessage: "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਆਪਣਾ ਡੇਅਰੀ ਲੋਗੋ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
  logoChangeButton: "ਲੋਗੋ ਬਦਲੋ",
};
